import { useState, useEffect } from 'react';

export const useFacilityState = () => {
  const [facilityId, setFacilityId] = useState<string | null>(() => {
    return localStorage.getItem('facilityId');
  });
  const [clinicName, setClinicName] = useState<string | null>(() => {
    return localStorage.getItem('clinicName');
  });

  useEffect(() => {
    if (facilityId) {
      localStorage.setItem('facilityId', facilityId);
    } else {
      localStorage.removeItem('facilityId');
    }
  }, [facilityId]);

  useEffect(() => {
    if (clinicName) {
      localStorage.setItem('clinicName', clinicName);
    } else {
      localStorage.removeItem('clinicName');
    }
  }, [clinicName]);

  return { facilityId, setFacilityId, clinicName, setClinicName };
};
